import { render, staticRenderFns } from "./AdminCourseRequests.vue?vue&type=template&id=9f5df638&scoped=true"
import script from "./AdminCourseRequests.vue?vue&type=script&lang=js"
export * from "./AdminCourseRequests.vue?vue&type=script&lang=js"
import style0 from "./AdminCourseRequests.vue?vue&type=style&index=0&id=9f5df638&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5df638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5df638')) {
      api.createRecord('9f5df638', component.options)
    } else {
      api.reload('9f5df638', component.options)
    }
    module.hot.accept("./AdminCourseRequests.vue?vue&type=template&id=9f5df638&scoped=true", function () {
      api.rerender('9f5df638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCourseRequests.vue"
export default component.exports